import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import { TYPE, COLORS } from "../../../theme/styles/globals"

export default class ContentfulBlockResults extends React.Component {
  render() {
    const { mode, results } = this.props

    return (
      <Container>
        {results.map((result, i) => (
          <Result key={i}>
            <Image src={result.image.file.url} />
            <TextWrap>
              <Large mode={mode}>{result.largeText}</Large>
              <Small
                mode={mode}
                dangerouslySetInnerHTML={{ __html: result.smallText }}
              />
            </TextWrap>
          </Result>
        ))}
      </Container>
    )
  }
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;

  ${up("md")} {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`

const Result = styled.div`
  width: 100%;

  margin-bottom: 40px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;

  ${up("md")} {
    flex-direction: row;
    height: 150px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
`

const Image = styled.img`
  width: 150px;
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;

  ${up("md")} {
    margin-bottom: 30px;
  }
`

const TextWrap = styled.div`
  text-align: center;
  padding-left: 24px;
  padding-right: 24px;

  ${up("md")} {
    text-align: left;
    width: 550px;
    padding-left: 65px;
    line-height: 0px;
    padding-right: 0px;
  }
`
const Large = styled.h3`
  font-size: 90px;
  line-height: 90px;
  font-family: ${TYPE.SERIF_BOLD_FONT};
  margin-top: 0px;
  margin-bottom: 0px;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};

  ${up("md")} {
    font-size: 128px;
    line-height: 128px;
  }
`
const Small = styled.p`
  font-size: 10px;
  font-family: ${TYPE.MONO_FONT};
  line-height: 14px;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
`
